import { Route, mapToCanActivate, mapToCanDeactivate } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { RouterFragments } from '@core/model/RouterFragments';
import { PortalProducts } from '@shared/enumeration';
import { AccessPageGuard } from '@mynexus/mynexus-ui-lib';
import { authDetailsTitleResolver } from '@core/resolvers/auth-details-title.resolver';
import { NotesGuard } from '@core/guards/notes.guard';
import { AuthorizationRequestComponent } from '@products/dmepos/pages/authorization-request/authorization-request.component';
import { ProviderDashboardComponent } from '@products/dmepos/pages/provider-dashboard/provider-dashboard.component';

export default [
  {
    path: `:tenantId/${PortalProducts.DMEPOS}/provider-dashboard`,
    component: ProviderDashboardComponent,
    title: 'Provider Dashboard',
    data: {
      permissions: ['DMEPOSProviderDashboard.Read'],
    },
    canActivate: mapToCanActivate([AccessPageGuard]),
  },
  {
    path: `:tenantId/${PortalProducts.DMEPOS}/member/:memberId/request-initial`,
    component: AuthorizationRequestComponent,
    title: 'Authorization Request',
    data: {
      permissions: ['DMEPOSAuthorization.Create'],
    },
    canActivate: mapToCanActivate([MsalGuard, AccessPageGuard]),
  },
  {
    path: `:tenantId/${PortalProducts.DMEPOS}/member/:memberId/request-initial/:authorizationByProductId`,
    component: AuthorizationRequestComponent,
    title: 'Authorization Request',
    data: {
      permissions: ['DMEPOSAuthorization.Create'],
    },
    canActivate: mapToCanActivate([MsalGuard, AccessPageGuard]),
  },
  {
    path: `:tenantId/${PortalProducts.DMEPOS}/auth-dashboard/${RouterFragments.UNKNOWN}`,
    loadChildren: () => import('@pages/auth-detail-not-found/auth-detail-not-found.module')
      .then((m) => m.AuthDetailNotFoundModule),
    title: 'Auth Details Not Found',
    canActivate: mapToCanActivate([MsalGuard]),
  },
  {
    path: `:tenantId/${PortalProducts.DMEPOS}/auth-dashboard/:authorizationNumber`,
    loadChildren: () => import('@products/dmepos/pages/authorization-details/authorization-details.module')
      .then((m) => m.AuthorizationDetailsModule),
    title: authDetailsTitleResolver('Auth Details'),
    data: {
      permissions: ['DMEPOSAuthorization.Read'],
    },
    canActivate: mapToCanActivate([MsalGuard, AccessPageGuard]),
    canDeactivate: mapToCanDeactivate([NotesGuard]),
  },
] as Route[];
